import Component from '../abstracts/Component';

export default class NewSizesComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-variant-list',
    };
  }

  get CLASSES() {
    return {
      selected: 'selected',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
  }

  onSelectChange(el) {

    var ctx = this;

    $(el).on('select2:select', function (e) {
      var isWishlist = e.target.parentElement.classList.contains('pdp-select') ? false : true;
      var localizedSize = e.params.data.element.value;
      if(!isWishlist){
        // per dpd aggiorno tutte le size select
        $(ctx.SELECTORS.main).val(localizedSize);
        $(ctx.SELECTORS.main).trigger('change');
      }
      var dataset = e.params.data.element.dataset;
      ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizechanged, {
        isWishlist: isWishlist,
        baseCode: dataset.baseCode,
        code: dataset.code,
        notify: dataset.notify == "true" ? true : false,
        size: localizedSize
      });
    });

  }

  render() {
    var elements = document.querySelectorAll(this.SELECTORS.main);
    if (elements.length > 0) {
      elements.forEach(element => {
        this.onSelectChange(element);
      });
    }
  }
}
